export default "__VITE_ASSET__CC3HCYuA__"